import ProdConfig from '../../../config/prod.json';

const productionBaseUrl = ProdConfig['countertops-base-url'];

export const QUERY_PARAM_SAMPLE_OMSID = 'sampleOmsId';
export const QUERY_PARAM_DRAFT_OMSID = 'draftProductId';
export const QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS = 'baseConfigurationIdForSelections';
export const QUERY_PARAM_CONFIGURATION_ID_FOR_SELECTIONS = 'configurationIdForSelections';
export const QUERY_PARAM_PLA_CONFIGURATION_GUID = 'plaGuid';
export const QUERY_PARAM_COLOR_CHOICE_ID = 'colorChoiceId';
export const QUERY_PARAM_REGION_ID = 'region_id';
export const QUERY_OMS_ID = 'omsid';
export const QUERY_STORE_ID = 'storeId';
export const QUERY_STORE_ZIPCODE = 'zipcode';
export const QUERY_FILTERS_ID = 'filters';
export const POST_FORM_TESTING_PARAM = 'postFormTestingParam';

export class Utils {
  static parseUrl(url) {
    if (typeof document === 'undefined') return null;
    let link = document.createElement('a');

    link.setAttribute('href', url);

    const retValue = {
      port: link.port,
      hostname: link.hostname,
      pathname: link.pathname,
      protocol: link.protocol,
      search: link.search,
    };

    link = null;

    return retValue;
  }

  static getUrlBaseAddress() {
    const link = this.parseUrl(this.getUrlAddress());
    let baseAddress = `${link.protocol}//${link.hostname}`;
    if (link.port) { return `${baseAddress}:${link.port}`; }
    return baseAddress;
  }

  static getBaseURI() {
    const link = this.parseUrl(this.getUrlAddress());
    let baseAddress = `${link.protocol}//${link.hostname}`;
    if (link.port) { baseAddress = `${link.protocol}//${link.hostname}:${link.port}`; }
    return `${baseAddress}${link.pathname}`;
  }

  static getUrlAddress = () => typeof window !== 'undefined' && window.location.href;

  static getLastItem = (thePath) => thePath.substring(thePath.lastIndexOf('/') + 1);

  static getOmsIdFromUrl = () => {
    return this.getLastItem(this.parseUrl(this.getUrlAddress()).pathname);
  }

  static getParameterByName = (parameter, url = this.getUrlAddress()) => {
    const cleanParam = parameter.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${cleanParam}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  static getEnvironment = () => {
    const envLink = this.parseUrl(this.getUrlAddress());
    if (envLink === null) return null;

    const {
      protocol, hostname, port, pathname, search
    } = envLink;
    return ({
      protocol, hostname, port, pathname, search
    });
  }

  static containsNucleusPath = () => {
    const envLink = this.parseUrl(this.getUrlAddress());
    return envLink.pathname.indexOf('render-nucleus') > 0;
  }

  static isNucleusProdEnvironment = () => {
    const baseUrl = (typeof window !== 'undefined') ? window.__EXPERIENCE_PROPS__?.expConfiguration?.['countertops-base-url'] : null;
    return baseUrl === productionBaseUrl;
  }

  static deleteQueryParam = (searchString, paramToDelete) => {
    const params = new URLSearchParams(searchString);
    params.delete(paramToDelete);
    return (`?${params.toString()}`);
  }

  static hasPlaConfigSelections = () => {
    const hasPlaConfigSelections = new URLSearchParams((typeof window !== 'undefined') ? window.location.search : '');
    return !!hasPlaConfigSelections.get(QUERY_PARAM_CONFIGURATION_ID_FOR_SELECTIONS);
  }

  static hasPlaGuid = () => {
    if (typeof window === 'undefined') return null;
    const hasPlaGuid = new URLSearchParams((typeof window !== 'undefined') ? window.location.search : '');
    return !!hasPlaGuid.get(QUERY_PARAM_PLA_CONFIGURATION_GUID);
  }

  static hasItemInUrl() {
    const url = this.getUrlAddress();
    return url.includes('item');
  }

  static deleteAddQueryParameters = (paramListToDelete, paramListToAdd, url = this.getUrlAddress()) => {
    const { search } = this.parseUrl(url);
    const params = new URLSearchParams(search);
    paramListToDelete.forEach((param) => params.delete(param));
    paramListToAdd.forEach((param) => params.append(param.name, param.value));
    if (params.size >= 1) {
      return (`?${params.toString()}`);
    }
    return '';
  }

  static getFilters = (currentOmsId) => {
    if (typeof window === 'undefined') return [];
    const url = new URL(window.location.href);
    const urlFilters = JSON.parse(url.searchParams.get(QUERY_FILTERS_ID));
    const sessionStorageFilters = JSON.parse(sessionStorage.getItem(QUERY_FILTERS_ID));
    if (sessionStorageFilters && sessionStorageFilters[currentOmsId]) {
      return sessionStorageFilters[currentOmsId];
    }
    return urlFilters || [];
  }

  static setFilters = (selectedFilters, omsId) => {
    if (typeof window === 'undefined') return;
    const url = new URL(window.location.href);
    if (selectedFilters.length === 0) {
      url.searchParams.delete(QUERY_FILTERS_ID);
    } else {
      url.searchParams.set(QUERY_FILTERS_ID, JSON.stringify(selectedFilters));
    }
    const sessionStorageFilters = JSON.parse(sessionStorage.getItem(QUERY_FILTERS_ID)) || {};
    sessionStorageFilters[omsId] = selectedFilters;
    window.history.replaceState(window.history.state, '', url);
    sessionStorage.setItem(QUERY_FILTERS_ID, JSON.stringify(sessionStorageFilters));
  }
}

const utils = { Utils };

export default utils;
